import { AlignmentType, HeadingLevel, Paragraph, TextRun, WidthType } from "docx";

export const frameworkHeading = new Paragraph({
    spacing: { before: 150, after: 100 },
    children: [new TextRun({
        text: "6.  Framework used for Audit",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
    heading: HeadingLevel.HEADING_2,
})

export const framework = new Paragraph({
    spacing: { before: 250, after: 100 },
    children: [new TextRun({
        text: "6.1   Framework",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export function frameworkText(certInApplicationName, certInCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 200 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION used Audit Methodologies like OWASP Code Review, CERT Secure Coding Standards, CWE/SANS Top 25, frameworks to execute the ${certInApplicationName} belonging to ${certInCustomerName}.`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}


export const areaCovered = new Paragraph({
    spacing: { before: 350, after: 300 },
    children: [new TextRun({
        text: "6.2   Area Covered in Security Audit",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export const areaCoveredText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The following tests are conducted as part of the Security Audit:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})


export const auditPoint1 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Hardcoded Credentials in the code",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint2 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Hardcoded Secret",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint3 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "SQL Injection",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint4 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "XML External Entity (XXE) Injection",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})
export const auditPoint5 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Path Manipulation",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint6 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Unsecure Cipher Mode/ Padding Scheme",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint7 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Insufficient Cryptography",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint8 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Insecure Authentication",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint9 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Improper Export of Android Components",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})
export const auditPoint10 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Insecure Data Transmission",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint11 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Insecure Hostname Validation",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint12 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Inadequate Encryption Strength",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint13 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Sensitive Information Exposure",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint14 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Pseudorandom Number Generators",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint15 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Dynamically Executing Code",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint16 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Weak Cryptography",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint17 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Information Exposure Through Debug",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint18 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Cleartext Traffic",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint19 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Weak Hash Algorithm",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint20 = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Insecure Configuration",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})